import { inject, Injectable } from '@angular/core';
import { Indicator, xlsxColumnProperties } from '../models/indicator';
import { CategoryStore } from '../stores/category/category.state';
import { TagStore } from '../stores/tag/tag.state';
import { IndicatorStore } from '../stores/indicator/indicator.state';
import { unitMapping } from '../models/unit';
import { MarkdownService } from './markdown.service';

@Injectable({
  providedIn: 'root',
})
export class IndicatorExportConverterService {
  readonly indicatorStore = inject(IndicatorStore);
  readonly categoryStore = inject(CategoryStore);
  readonly tagStore = inject(TagStore);
  propertyMapping = xlsxColumnProperties;

  constructor(private markdownService: MarkdownService) {}

  prepareIndicatorsForExport(indicators: Indicator[]): any {
    return indicators
      .filter((indicator: Indicator) => !!indicator.category && !indicator.pool)
      .map(row =>
        this.propertyMapping.map(property =>
          this.castIndicatorPropertyToXlsx(property, row[property])
        )
      );
  }

  castIndicatorPropertyToXlsx(property: string, value: any): any {
    switch (property) {
      case 'tags':
      case 'products':
        return value
          ? value
              .filter((tagId: string) => !!this.tagStore.getById(tagId))
              .map((tagId: string) => this.tagStore.getById(tagId).title)
              .join(';')
          : '';
      case 'category':
        return this.categoryStore.getById(value)?.name ?? '';
      case 'decimals':
        return value === -1 ? '' : value;
      case 'unit':
        return value && unitMapping[value] ? unitMapping[value] : '';
      case 'locked':
      case 'isSet':
        return value ? '1' : '0';
      case 'legend':
        return value && Array.isArray(value) && value.length ? value : '';
      case 'parent':
        return value && this.indicatorStore.getById(value)
          ? this.indicatorStore.getById(value).key
          : '';
      case 'hint':
      case 'indication':
      case 'source':
      case 'statement':
      case 'calculation':
      case 'dataCycle':
      case 'levelOfAvailability':
      case 'dataSupplier':
        return value ? this.markdownService.convertToMarkdown(value) : '';
      default:
        return value ? value : '';
    }
  }
}
